import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["retryButton", "timerText", "timerIcon", "retryForm"]

  connect() {
    this.lockoutRemaining = parseInt(this.data.get("lockoutRemaining") || "0")
    this.attempts = parseInt(this.data.get("attempts") || "0")
    this.maxAttempts = parseInt(this.data.get("maxAttempts") || "3")

    this.lockoutEndTime = null
    this.intervalId = null

    if (this.attempts >= this.maxAttempts) {
      this.disableButton()
      return
    }

    if (this.lockoutRemaining > 0) {
      this.lockoutEndTime = Date.now() + this.lockoutRemaining
      this.startTimer()
    }
  }

  disconnect() {
    this.stopTimer()
  }

  startTimer() {
    this.disableButton()
    this.tick()
    this.intervalId = setInterval(() => this.tick(), 1000)
  }

  stopTimer() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
      this.intervalId = null
    }
  }

  tick() {
    if (!this.lockoutEndTime) {
      this.stopTimer()
      return
    }

    var remaining = this.lockoutEndTime - Date.now()

    if (remaining <= 0) {
      this.stopTimer()
      this.lockoutEndTime = null
      this.enableButton()
      this.showAvailable()
      return
    }

    var minutesLeft = Math.ceil(remaining / 60000)
    this.showCountdown(minutesLeft)
  }

  showCountdown(minutes) {
    if (!this.hasTimerTextTarget) return

    if (minutes === 1) {
      this.timerTextTarget.textContent = "Retry available: In 1 minute"
    } else {
      this.timerTextTarget.textContent = "Retry available: In " + minutes + " minutes"
    }
  }

  showAvailable() {
    if (this.hasTimerTextTarget) {
      this.timerTextTarget.textContent = "Retry available: Now"
    }
    if (this.hasTimerIconTarget) {
      this.timerIconTarget.classList.remove("fa-clock")
      this.timerIconTarget.classList.add("fa-check-circle")
    }
  }

  // button state
  disableButton() {
    if (this.hasRetryButtonTarget) {
      this.retryButtonTarget.disabled = true
      this.retryButtonTarget.classList.add("disabled")
    }
  }

  enableButton() {
    if (this.hasRetryButtonTarget && this.attempts < this.maxAttempts) {
      this.retryButtonTarget.disabled = false
      this.retryButtonTarget.classList.remove("disabled")
    }
  }
}
